import React, { useEffect, useState } from "react";
import styles from "./inActiveBlog.module.scss";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { connect, useDispatch } from "react-redux";
import {
  getActiveProducts,
  getBlogsByIdResponse,
  getInActiveBlogs,
} from "../../store/actions";
import EditIcon from "@mui/icons-material/Edit";
import { getObjectFromArrayOfObjects } from "../../utils/common/CommonFunctions";

const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "IMAGE",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "BLOG NAME",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "PRODUCTS",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "ACTION",
    minWidth: 170,
    align: "center",
  },
];

const InActiveBlog = ({ inActiveBlogs = [], activeProducts = [] }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [productPopupOpen, setProductPopupOpen] = useState(false);
  const [productPopupItems, setProductPopupItems] = useState([]);
  const [productPopupTitle, setProductPopupTitle] = useState("Linked Products");
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    dispatch(getInActiveBlogs());
    dispatch(getActiveProducts());
  }, [dispatch]);

  const handleEdit = (item = {}) => {
    dispatch(getBlogsByIdResponse(item));
    navigate("/blogManage");
  };

  const closeProductPopup = () => {
    setProductPopupOpen(false);
    setProductPopupItems([]);
  };

  const getImageUrl = (item = {}) =>
    item?.imageUrl ||
    item?.image ||
    item?.imagePreviewDataUrl ||
    item?.imageUrls?.[0] ||
    "";

  const openProductPopUp = (item = {}) => {
    const normalizedProducts = [];

    const directProductNames = Array.isArray(item?.productDetails)
      ? item.productDetails
          .map((product) =>
            typeof product === "object" ? product?.name : undefined
          )
          .filter(Boolean)
      : [];

    const fromProductsArray = Array.isArray(item?.products)
      ? item.products
          .map((product) =>
            typeof product === "object"
              ? product?.name
              : getObjectFromArrayOfObjects(activeProducts, "id", product)?.name
          )
          .filter(Boolean)
      : [];

    const productIds = Array.isArray(item?.productId)
      ? item.productId
      : item?.productId
      ? [item.productId]
      : [];

    const fromIds = productIds
      .map((productId) =>
        getObjectFromArrayOfObjects(activeProducts, "id", productId)?.name
      )
      .filter(Boolean);

    normalizedProducts.push(
      ...directProductNames,
      ...fromProductsArray,
      ...fromIds
    );

    const uniqueProducts = [...new Set(normalizedProducts)].filter(Boolean);

    setProductPopupItems(uniqueProducts);
    setProductPopupTitle(item?.title || item?.name || "Linked Products");
    setProductPopupOpen(true);
  };

  const handlePreview = (item = {}) => {
    const url = getImageUrl(item);
    if (url) {
      setPreviewUrl(url);
    }
  };

  const getStructuredRows = (data = []) =>
    data?.map((item, idx) => {
      const imageUrl = getImageUrl(item);
      return {
        id: item?.id ?? idx,
        rColumns: [
          idx + 1,
          <div className={styles.imgtable}>
            <Button
              variant="outlined"
              className={styles.ovalButtonOutImg}
              disableRipple
              disableElevation
              onClick={() => handlePreview(item)}
              disabled={!imageUrl}
            >
              View
            </Button>
          </div>,
          item?.title || item?.name || "-",
          <Button
            variant="outlined"
            className={styles.ovalButtonOut}
            disableRipple
            disableElevation
            onClick={() => openProductPopUp(item)}
          >
            View
          </Button>,
          <div className={styles.imgtable} onClick={() => handleEdit(item)}>
            <EditIcon color="primary" />
            EDIT
          </div>,
        ],
      };
    });

  const handleNavigate = () => {
    dispatch(getBlogsByIdResponse(null));
    navigate("/blogManage");
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            <CustomButton
              title={"Add"}
              txtClr={"#FFFFFF"}
              background={"black"}
              width={"141px"}
              height={"48px"}
              borderRadius={"12px"}
              onClick={handleNavigate}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(inActiveBlogs)}
          />
        </div>
      </div>
      <Dialog
        open={productPopupOpen}
        onClose={closeProductPopup}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle className={styles.productDialogTitle}>
          {productPopupTitle}
          <IconButton onClick={closeProductPopup} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {productPopupItems.length > 0 ? (
            <Box className={styles.productList}>
              {productPopupItems.map((productName, idx) => (
                <Box key={`${productName}-${idx}`} className={styles.productListItem}>
                  {productName}
                </Box>
              ))}
            </Box>
          ) : (
            <Box className={styles.emptyProductList}>No products linked</Box>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={!!previewUrl}
        onClose={() => setPreviewUrl("")}
        maxWidth="md"
        fullWidth
        PaperProps={{
          className: styles.previewPaper,
          sx: { borderRadius: "12px" },
        }}
      >
        <DialogContent classes={{ root: styles.previewContainer }}>
          <IconButton
            className={styles.previewClose}
            size="small"
            onClick={() => setPreviewUrl("")}
          >
            <CloseIcon />
          </IconButton>
          {previewUrl ? (
            <img
              src={previewUrl}
              alt="Blog Preview"
              className={styles.previewImage}
            />
          ) : (
            <Box className={styles.emptyPreview}>No image available</Box>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    inActiveBlogs: state?.blogs?.inActiveBlogs,
    activeProducts: state?.product?.activeProducts,
  };
};

export default connect(mapStateToProps, null)(InActiveBlog);
